import { api } from '../client';

export interface DashboardStats {
  total: number;
  connected: number;
  disconnected: number;
  registered: number;
  activePorts: number;
}

export interface StatsResponse {
  success: boolean;
  stats: DashboardStats;
}

export const dashboardApi = {
  stats: () =>
    api.get<StatsResponse>('/api/stats'),
};
